import { render, staticRenderFns } from "./ColiList.vue?vue&type=template&id=ce0356b4&"
import script from "./ColiList.vue?vue&type=script&lang=js&"
export * from "./ColiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports